import { render, staticRenderFns } from "./OrderReturnRemarks.vue?vue&type=template&id=75c6fdde"
import script from "./OrderReturnRemarks.vue?vue&type=script&lang=js"
export * from "./OrderReturnRemarks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports